module.exports = __webpack_public_path__ + "static/fancyTitleDefaultBack-750ba4412e6b5260db6541541d945cb4.png";